import { jsx as _jsx } from "react/jsx-runtime";
import { cdnClient, getCurrentMemberSubscription } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Image } from '../../../../subcomponents/image/image';
const b = bemClassBuilder('v-member-card-logo');
export const MemberCardLogo = observer(props => {
    var _a;
    const { showAsSubscription, clubId, cdnOptions } = props;
    const memberSubscriptionId = (_a = getCurrentMemberSubscription()) === null || _a === void 0 ? void 0 : _a.subscriptionId;
    const imageUrl = showAsSubscription && memberSubscriptionId !== undefined
        ? getSubscriptionLogoUrl(memberSubscriptionId, cdnOptions)
        : getLoyaltyClubLogoUrl(clubId, cdnOptions);
    return _jsx(Image, { className: b.block(), src: imageUrl });
});
MemberCardLogo.displayName = 'MemberCardLogo';
const getLoyaltyClubLogoUrl = (clubId, options) => {
    return cdnClient.instance.loyaltyClub(clubId.toString()).image(options === null || options === void 0 ? void 0 : options.clubLogo);
};
const getSubscriptionLogoUrl = (memberSubscriptionId, options) => {
    return cdnClient.instance.loyaltySubscription(memberSubscriptionId).image(options === null || options === void 0 ? void 0 : options.subscriptionLogo);
};
